import { render, staticRenderFns } from "./UserManagerView.vue?vue&type=template&id=c045f946&scoped=true"
import script from "./UserManagerView.vue?vue&type=script&lang=js"
export * from "./UserManagerView.vue?vue&type=script&lang=js"
import style0 from "./UserManagerView.vue?vue&type=style&index=0&id=c045f946&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c045f946",
  null
  
)

export default component.exports